module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/rating/rating.component.scss
// module id = ./src/app/limit-flow-proposal/component/rating/rating.component.scss
// module chunks = main